<script setup>
import { getWebsiteTopNews, getWebsiteContent, getFileInfo } from '@/api/api'
import { ref, onMounted } from "vue";
import store from "@/store";
import router from '@/router';

const props = defineProps({
  layout: {
    type: String,
    default: 'default', //default-头条 layout1-年审 layout2-带视频播放
  },
  contentNo: {
    type: String,
    default: '',
  }
})

const news = ref([])
if (props.layout == 'default') {
  getWebsiteTopNews('ws').then((res) => {
    if (res.state === 'SUCCESS') {
      news.value = res.data
      if (news.value?.length) {
        for (let item of news.value) {
          if (item.document) {
            getFileInfo(item.document).then(fileRes => {
              console.log('fileRes', fileRes)
            })
          }
        }
      }
    }
  })
} else if (props.contentNo) {
  onMounted(async () => {
    const res = await getWebsiteContent(props.contentNo)
    if (res.state === 'SUCCESS') {
      if (res.data?.length) {
        for (let item of res.data) {
          if (item.document) {
            item._document = []
            const fileRes = await getFileInfo(item.document)
            if (fileRes?.data?.length) {
              item._document = fileRes.data.map(e => {
                e['_url'] = `${store.getters.hostPath}/file/download?filePath=${e.fileurl}`
                return e
              })
            }
          }
        }
      }
      news.value = res.data
    }

  })
}
const toAdmin = () => {
  window.open(window.ipConfig?.adminPath || 'https://xxld.100xsys.cn:1443/main/index.html')
}
const toDetail = (content) => {
  // return
  if (content && content.category_no_path) {
    // 存在文章数据和栏目path时 处理跳转逻辑
    let noPath = content.category_no_path
    let root = noPath.split('/').filter(item => item)[0]
    let active = content.category_no

    let rootNavbar = store.getters.getNavs
    rootNavbar = rootNavbar.filter(item => item.key == root)[0]
    let path = rootNavbar.href
    let layoutType = 'none'

    if (rootNavbar && rootNavbar.level !== 1) {
      root = rootNavbar.path.split('/').filter(item => item)[0]
      if (root) {
        let loadRootNavBar = this.getNavBarData(root)
        path = loadRootNavBar.href
        store.commit('setActiveNav', loadRootNavBar)
      }

    } else {
      store.commit('setActiveNav', rootNavbar)
    }

    if (path == '/') {
      let to = this.getNavBarData(this.no)
      path = to.href
      root = to.key
      store.commit('setActiveNav', to)
    }
    if (path && path.indexOf('?') !== -1) {
      // 处理模板参数
      let pathParams = path.split('?')[1]
      path = path.split('?')[0]
      layoutType = pathParams.split('=')[1]
    }
    if (path && path.indexOf(':') !== -1) {
      path = path.split(':')[0]
    }
    if (!path) {
      let onItem = content
      path = onItem.category_no_path
      if (path) {
        path = path.split('/')
        path = path.filter(item => item)
        if (Array.isArray(path) && path.length > 1) {
          root = path[0]
          path = 'homePage'

          let navs = store.getters.getNavs
          navs = this.getTree(navs, 'key', 'parent_no', root)
          if (navs.length == 1) {
            navs = navs[0]
            store.commit('setActiveNav', navs)
          }
        }
      }
    }
    router.push(`/${path}/${root}/${content.category_no}/detail/${content.id}/${layoutType}`)
  }
}
</script>
<script>

</script>
<template>
  <div
    class="top-news"
    v-if="props.layout === 'default'"
  >
    <b-container class="d-flex justify-content-start top-news-center">
      <div class="badge">
        <div class="badge-left"></div>
        <div class="badge-right">
          头条新闻
        </div>
      </div>
      <div
        class="news-item"
        v-for="item in news"
        :key="item.id"
        :title="item.title"
        @click="toDetail(item)"
      >
        {{ item.title }}
      </div>
      <div class="right">
        <b-icon icon="three-dots-vertical"></b-icon>
      </div>
    </b-container>
  </div>
  <div
    class="layout-2"
    v-else-if="layout === 'layout2'"
  >
    <div
      class="layout-2-item"
      v-for="item in news"
      :key="item.id"
      :title="item.title"
      @click="toDetail(item)"
    >
      <div class="left">
        <div class="title">{{ item.title }}</div>
        <div
          class="content"
          v-html="item.content"
        ></div>
        <div class="content"></div>
        <button
          class="bg-blue"
          @click="toAdmin"
        >立即进入</button>
      </div>
      <div class="right-icon"></div>
    </div>
  </div>
  <div
    class="layout-3"
    v-else-if="layout === 'layout3'"
  >
    <div
      class="layout-3-item cursor-pointer"
      v-for="item in news"
      :key="item.id"
      :title="item.title"
      @click="toDetail(item)"
    >
      <b-row>
        <b-col>
          <div class="left">
            <div class="title">{{ item.title }}</div>
            <div
              class="content"
              v-html="item.content"
            ></div>
            <div class="content"></div>
          </div>
        </b-col>
        <b-col class="justify-content-end d-flex">
          <div class="right">
            <template v-if="item._document && item._document.length">
              <div
                class="file-box"
                :key="file.id"
                v-for="file in item._document"
              >
                <video
                  v-if="file && file.file_type === 'mp4'"
                  :src="file._url"
                  controls
                ></video>
              </div>
            </template>
          </div>
        </b-col>
      </b-row>

    </div>
  </div>
  <div
    class="layout-4"
    v-else-if="layout === 'layout4'"
  >
    <div class="left">
      <div class="top">
        <span class="label">服务时间</span>
        <span>09:00-18:00（节假日休息）</span>
      </div>
      <div class="center">政务咨询：029-88668926
      </div>
      <div class="center">服务热线：029-81105420</div>
    </div>
    <div class="right">
      <img
        class="qrcode"
        src="../assets/qrcode/qrcode.jpg"
      >
      <span>扫描二维码，添加客服的企业微信</span>
    </div>
  </div>
</template>

<style lang="scss">
.layout-4 {
  text-align: left;
  padding: 2vw;
  //height: 0.13vw;
  min-height: 200px;
  box-sizing: border-box;
  display: flex;

  .right {
    display: flex;
    flex-direction: column;
    align-items: center;

    .qrcode {
      width: 145px;
      height: 145px;
      border-radius: 8px;
      border: 1px solid #ccc;
      padding: 6px;
    }

    span {
      font-size: 12px;
      color: #999;
      margin-top: 10px;

    }
  }

  .left {
    flex: 1;

    .top {
      display: inline-block;
      height: 50px;
      line-height: 50px;
      border-radius: 99px;
      background: linear-gradient(88deg, rgba(212, 228, 242, 1) -4.98%, rgba(212, 228, 242, 1) 20%, rgba(196, 225, 255, 0) 97.47%);
      color: #333;
      font-size: 24px;
      text-align: center;
      font-family: Roboto;
      padding-right: 20px;
      margin-bottom: 10px;

      .label {
        display: inline-block;
        width: 164px;
        height: 50px;
        line-height: 50px;
        border-radius: 99px;
        background-color: rgba(38, 90, 175, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        margin-right: 20px;
      }
    }

    .center {
      height: 40px;
      line-height: 40px;
      color: rgb(33, 33, 33);
      font-size: 20px;
      text-align: left;
      font-family: SourceHanSansSC-medium;
    }
  }
}


.layout-3 {
  background: #fff;
  padding: 2rem;
  border-radius: 10px;

  &-item {
    display: flex;
  }

  .left {
    flex: 1;

    .title {
      line-height: 50px;
      color: rgba(0, 40, 130, 1);
      font-size: 36px;
      text-align: left;
      margin-bottom: 10px;
    }
  }

  .right {
    width: 420px;
    height: 308px;
    background-color: rgb(89, 90, 92);

    .file-box {
      video {
        width: 100%;
        height: 100%;
        background-color: rgb(89, 90, 92);
      }
    }
  }
}

.layout-2 {
  .title {
    line-height: 50px;
    color: #002882;
    font-size: 36px;
    text-align: left;
  }

  .bg-blue {
    background-color: #265aaf;
    color: #fff;
    border-radius: 50px;
    border: none;
    padding: 2px 20px;
  }
}


.top-news {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-news-center {
  display: flex;
  align-items: center;

  .news-item {
    margin-left: 35px;
    font-size: 28px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }

  .right {
    text-align: right;
    width: 100px;
  }
}
</style>